import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import React, {forwardRef, useEffect, useImperativeHandle, useMemo} from 'react'
import {capitalize} from '../../utils/CommonUtils'
import {genderList} from '../patient/PatientConstants'

const CodeConfig = forwardRef(
    (
        {
            id,
            defaultValue = {
                codeConfig: {
                    userCodeRules: [],
                },
            },
            isLock = true,
            onChange = () => {},
        },
        ref,
    ) => {
        useSignals()
        useImperativeHandle(ref, () => ({
            getValue: handleGetData,
        }))

        const data = useSignal({
            codeConfig: {
                userCodeRules: [],
            },
        })

        useEffect(() => {
            if (defaultValue) {
                data.value = defaultValue
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [defaultValue])

        const displayValue = useMemo(() => {
            let resultData = {}

            if (
                !data.value ||
                !data.value?.userCodeRules ||
                !data.value?.userCodeRules.length
            ) {
                genderList.forEach(
                    gender =>
                        (resultData[gender] = {
                            padding: '',
                            genderCode: '',
                        }),
                )

                return resultData
            }

            data.value?.userCodeRules?.forEach(genderItem => {
                if (genderItem && genderItem?.gender) {
                    resultData[genderItem?.gender] = {
                        padding: genderItem?.padding || '',
                        genderCode: genderItem?.genderCode || '',
                    }
                }
            })

            return resultData
        }, [data.value])

        const handleGetData = () => {
            if (!data.value || !data.value?.userCodeRules?.length) {
                return {
                    codeConfig: {
                        userCodeRules: [],
                    },
                }
            }

            return data.value
        }

        const handleOnChangeInnerText = (gender, value, dataType) => {
            if (
                !data.value ||
                !data?.value ||
                !data?.value?.userCodeRules?.length
            ) {
                data.value = {
                    userCodeRules: [
                        {
                            gender: gender,
                            [dataType]: value,
                        },
                    ],
                }

                return
            }

            let holderData = data.value?.userCodeRules

            let genderIndex = holderData.findIndex(
                item => item.gender === gender,
            )

            if (genderIndex === -1) {
                holderData.push({
                    gender: gender,
                    [dataType]: value,
                })
            } else {
                holderData[genderIndex] = {
                    ...holderData[genderIndex],
                    [dataType]: value,
                }
            }

            if (holderData && holderData?.length) {
                data.value = {
                    userCodeRules: [...holderData],
                }
            }
        }

        return (
            <React.Fragment>
                <div className="flex flex-column gap-1 mb-3">
                    <label className="text-md text-700">
                        This section is used to create patients' codes based on
                        client requirements
                    </label>

                    <label className="text-md text-700">
                        For example: CW 1 000 1
                    </label>
                </div>
                {genderList.map(gender => (
                    <div className="col-12 px-0" key={gender}>
                        <div className={'grid grid-nogutter px-0'}>
                            <div className="col flex flex-column gap-2">
                                <label className="text-md font-bold text-700 mb-0">
                                    Prefix
                                </label>

                                <label className="mb-0 pt-1 ">
                                    Hospital Name
                                </label>
                            </div>
                            <div className="col px-2 flex flex-column gap-2">
                                <label className="text-md font-bold text-700 mb-0">
                                    Gender
                                </label>
                                <label className="mb-0 pt-1">
                                    {gender ? capitalize(gender) : '-'}
                                </label>
                            </div>
                            <div className="col px-2 flex flex-column gap-2">
                                <label className="text-md font-bold text-700 mb-0">
                                    Gender Code
                                </label>
                                <div className="flex">
                                    <div
                                        id={`${gender}-genderCode`}
                                        contentEditable={!isLock}
                                        suppressContentEditableWarning={true}
                                        className={`mb-0 ${
                                            !isLock ? 'bg-gray-100' : ''
                                        } p-1 border-round-sm `}
                                        style={{minWidth: '5rem'}}
                                        onInput={e => {
                                            handleOnChangeInnerText(
                                                gender,
                                                e.currentTarget.innerText,
                                                'genderCode',
                                            )
                                        }}>
                                        {displayValue &&
                                        displayValue[gender] &&
                                        displayValue[gender]['genderCode']
                                            ? displayValue[gender]['genderCode']
                                            : isLock
                                            ? '-'
                                            : ''}
                                    </div>
                                </div>
                            </div>
                            <div className="col px-2 flex flex-column gap-2">
                                <div>
                                    <label className="text-md font-bold text-700 mb-0">
                                        Padding
                                    </label>
                                </div>
                                <div className="flex">
                                    <div
                                        id={`${gender}-padding`}
                                        contentEditable={!isLock}
                                        suppressContentEditableWarning={true}
                                        className={`mb-0 ${
                                            !isLock ? 'bg-gray-100' : ''
                                        } p-1 border-round-sm `}
                                        style={{minWidth: '5rem'}}
                                        onInput={e => {
                                            handleOnChangeInnerText(
                                                gender,
                                                e.currentTarget.innerText,
                                                'padding',
                                            )
                                        }}>
                                        {displayValue &&
                                        displayValue[gender] &&
                                        displayValue[gender]['padding']?.length
                                            ? displayValue[gender]['padding']
                                            : isLock
                                            ? '-'
                                            : ''}
                                    </div>
                                </div>
                            </div>
                            <div className="col px-2 flex flex-column gap-2">
                                <div>
                                    <label className="text-md font-bold text-700 mb-0">
                                        Suffix
                                    </label>
                                </div>

                                <label className="mb-0 pt-1">Current ID</label>
                            </div>
                        </div>
                    </div>
                ))}
            </React.Fragment>
        )
    },
)

export default CodeConfig
